<template>
			<div id="page-content">
				<div id="log-in" style="background: url('static/images/b.jpeg') no-repeat center center; background-size: cover;">
				
					<div id="supplierinfo" class="col-md-8">
						<h1>Supplier Registration</h1>
						<p>this template currently applies for suppliers</p>
						<ul>
							<li>Post your products</li>
							<li>Get notifications and feedbacks about your products</li>
						</ul>
					</div>
					
					<div id="register" class="col-md-4">
						<h1>Sign Up!</h1>
						<form v-on:submit.prevent="supplierRegister">
							<h3>Account Information</h3>
							
							<label for="name">Full name</label>
							<input type="text" name="name" id="name" placeholder="Full name" />
							
							<label for="username">Username</label>
							<input type="text" name="username" id="username" placeholder="username" />
							
							<label for="email">Email</label>
							<input type="text" name="email" id="email" placeholder="email" />
							
							<label for="password">Password</label>
							<input type="password" name="password" id="password" placeholder="password" />
							
							<label for="password_confirmation">Confirm Password</label>
							<input type="password" name="password_confirmation" id="password_confirmation" placeholder="Confirm Password" />
							
							<h3>Supplier Information</h3>
							
							<label for="company_name">Company Name</label>
							<input type="text" name="company_name" id="company_name" placeholder="Company name" />
							
							<label for="company_address">Company Address</label>
							<input type="text" name="company_address" id="company_address" placeholder="Company address" />
							
							<label for="contact_number">Contact Number</label>
							<input type="text" name="contact_number" id="contact_number" placeholder="Contact number" />
							
							<input type="hidden" name="token" value="value" />
							<button type="submit">Register</button>
						</form>
					</div>
					
				</div>
			</div>
</template>

<script>
	export default{
		props: ['issessionset'],
		data(){
			return{

			}
		},
		methods: {
			supplierRegister: function(event){
				var data  = $(event.target).serialize();
				//Supplier register
			}
		},
		created(){
			if(this.issessionset === true){
				this.$router.push({path: '/user'});
			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		},
		watch: {
			issessionset: function(newval){
				if(newval === true){
					this.$router.push({path: '/user'});
				}		
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Supplier.vue?57f76e1c